export class CouponModel 
{
    constructor(id:string, name:string, valuestring:string, finalvalue:number, finalvaluestring:string, floorvalue:number, mode:number, value:number, percentage:number)
    {
        this.ID=id;
        this.Name=name;
        this.ValueString = valuestring;
        this.FinalValue = finalvalue;
        this.FinalValueString = finalvaluestring;
        this.FloorValue = floorvalue;
        this.Mode = mode;
        this.Value = value;
        this.Percentage = percentage;
    }

    public ID;
    public Name;
    public ValueString;
    public FinalValue;
    public FinalValueString;

    public FloorValue;
    public Mode;
    public Value;
    public Percentage;
}